"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Popconfirm = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _Icon = require("./Icon.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Icon組件
 */
var materialIconType = {
  default: "material-icons",
  outLined: "material-icons-outlined",
  twoTone: "material-icons-two-tone",
  rounded: "material-icons-round",
  sharp: "material-icons-sharp"
};

var Icon = function Icon(_ref) {
  var name = _ref.name,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "default" : _ref$type,
      rotate = _ref.rotate,
      color = _ref.color,
      bgcolor = _ref.bgcolor,
      onClick = _ref.onClick,
      mr = _ref.mr,
      disabled = _ref.disabled,
      _ref$clickable = _ref.clickable,
      clickable = _ref$clickable === void 0 ? false : _ref$clickable,
      focus = _ref.focus,
      focuscolor = _ref.focuscolor;
  return /*#__PURE__*/_react.default.createElement(_Icon.UiIcon, {
    rotate: rotate,
    color: disabled ? "#e7e7ed" : color,
    bgcolor: bgcolor,
    focus: focus,
    focuscolor: focuscolor,
    onClick: onClick,
    mr: mr,
    disabled: disabled,
    clickable: clickable
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: materialIconType[type]
  }, name));
};

var Popconfirm = function Popconfirm(_ref2) {
  var name = _ref2.name,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? "default" : _ref2$type,
      rotate = _ref2.rotate,
      color = _ref2.color,
      bgcolor = _ref2.bgcolor,
      mr = _ref2.mr,
      disabled = _ref2.disabled,
      _ref2$clickable = _ref2.clickable,
      clickable = _ref2$clickable === void 0 ? false : _ref2$clickable,
      icon = _ref2.icon,
      focuscolor = _ref2.focuscolor,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? "內文唷" : _ref2$title,
      _ref2$getPopupContain = _ref2.getPopupContainer,
      getPopupContainer = _ref2$getPopupContain === void 0 ? function () {
    return document.getElementById("IconPop");
  } : _ref2$getPopupContain,
      _ref2$onConfirm = _ref2.onConfirm,
      onConfirm = _ref2$onConfirm === void 0 ? function () {} : _ref2$onConfirm;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      popup = _useState2[0],
      setPopup = _useState2[1];

  var onConfirmHandle = function onConfirmHandle() {
    setPopup(false);
    onConfirm();
  };

  return /*#__PURE__*/_react.default.createElement(_Icon.UiIconPop, {
    id: "IconPop"
  }, /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
    placement: "bottom",
    title: title,
    icon: icon,
    visible: popup,
    onConfirm: onConfirmHandle,
    onCancel: function onCancel() {
      return setPopup(false);
    },
    okText: "\u78BA\u5B9A",
    cancelText: "\u53D6\u6D88",
    getPopupContainer: getPopupContainer
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    name: name,
    type: type,
    focus: popup,
    focuscolor: focuscolor,
    rotate: rotate,
    color: disabled ? "#e7e7ed" : color,
    bgcolor: bgcolor,
    onClick: function onClick() {
      return setPopup(true);
    },
    mr: mr,
    disabled: disabled,
    clickable: clickable
  })));
};

exports.Popconfirm = Popconfirm;
var _default = Icon;
exports.default = _default;
Icon.propTypes = {
  name: _propTypes.default.string,
  type: _propTypes.default.string,
  rotate: _propTypes.default.number,
  color: _propTypes.default.string,
  bgcolor: _propTypes.default.string,
  onClick: _propTypes.default.func,
  mr: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  clickable: _propTypes.default.bool,
  focus: _propTypes.default.bool,
  focuscolor: _propTypes.default.string
};
Popconfirm.propTypes = {
  name: _propTypes.default.string,
  type: _propTypes.default.string,
  rotate: _propTypes.default.number,
  color: _propTypes.default.string,
  focuscolor: _propTypes.default.string,
  bgcolor: _propTypes.default.string,
  onClick: _propTypes.default.func,
  mr: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  clickable: _propTypes.default.bool,
  icon: _propTypes.default.any,
  title: _propTypes.default.string,
  onConfirm: _propTypes.default.func,
  getPopupContainer: _propTypes.default.any
};